export const Topic = {
    "话题标题":"话题标题",
    "导入已有话题":"导入已有话题",
    "话题详情":"话题详情",
    "添加话题讨论":"添加话题讨论",
    "请输入留言":"请输入留言",
    "发表":"发表",
}